import { defineFcm } from '../shared/factory';

export const FCM_STARTER_EXPERIENCE_PETITION_ACTIVITY = defineFcm('starter_experience_petition_activity')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-axolotl',
		scope: 'corgi-front-end',
		context: 'corgi_frontend',
		description: 'Enables the visibility of links to the Petition Activity page in Starter Dashboard V2',
		import: false,
	});
